import React, { Fragment } from 'react';

import { FileOutlined, FileImageOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';

import Spin from 'components/Spin';
import { useLoadFiles } from 'v2/hooks/useLoadFiles';

import { useFiscalDocuments } from '../../context';

const ICONS: Record<string, React.ReactNode> = {
  jpeg: <FileImageOutlined />,
  jpg: <FileImageOutlined />,
  png: <FileImageOutlined />,
  gif: <FileImageOutlined />,
  pdf: <FilePdfOutlined />
};

const STATUSES = [undefined, 'Aguardando Aprovação', 'Aprovado', 'Reprovado'];

const Files = () => {
  const { selectedData } = useFiscalDocuments();
  const { files, isLoading } = useLoadFiles(selectedData.id);

  if (isLoading) {
    return (
      <div className='m-0! py-2 text-center'>
        <Spin />
      </div>
    );
  }

  if (!files.length) {
    return <p className='m-0! pt-5 text-center'>Nenhum registro encontrado.</p>;
  }

  return (
    <Fragment>
      {files.map(item => (
        <a key={item.id} href={item.url} target='_blank' rel='noopener noreferrer' className='block w-full capitalize'>
          <Row gutter={16} align='middle'>
            <Col flex='none'>
              <span className='text-lg'>{ICONS[item.ext] || <FileOutlined />}</span>
            </Col>
            <Col flex='auto'>
              <p className='m-0!'>{item.name}</p>
              <small className='-mt-1 block text-xs italic opacity-50'>
                {STATUSES[Number(item.status)] || 'Pendente'}
              </small>
            </Col>
          </Row>
        </a>
      ))}
    </Fragment>
  );
};

export default Files;
